import styles from "./FormPageNav.module.css";

export interface FormPageNavItem {
  key: string;
  label: string;
}

export interface FormPageNavProps {
  /** Pages in workflow order; every entry is navigable in both directions. */
  pages: readonly FormPageNavItem[];
  /** Zero-based index of the active page. */
  current: number;
  /** Called with the index of the page the user navigated to. */
  onSelect: (index: number) => void;
}

/**
 * Numbered page navigation for multi-page forms ("1. Details" →
 * "2. Scope"). Purely presentational and reusable: it owns no page
 * state — the host form keeps the active index so entered values survive
 * moving between pages. Renders nothing for a single-page workflow.
 */
export function FormPageNav({ pages, current, onSelect }: FormPageNavProps) {
  if (pages.length <= 1) return null;

  return (
    <nav className={styles.root} aria-label="Form pages">
      <ol className={styles.list}>
        {pages.map((page, index) => {
          const active = index === current;
          return (
            <li key={page.key}>
              <button
                type="button"
                className={active ? styles.stepActive : styles.step}
                aria-current={active ? "step" : undefined}
                onClick={() => onSelect(index)}
              >
                {/* {index + 1}. {page.label} */}
                {page.label}
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
